"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M18.593 6a3.074 3.074 0 00-.088-2.425c-.961-2.06-3.736-2.426-5.199-.685L12 4.445 10.694 2.89c-1.463-1.74-4.238-1.375-5.2.685A3.074 3.074 0 005.408 6H2v6h2v9h16v-9h2V6h-3.407zm-1.9-1.579a1.11 1.11 0 01-1.006 1.58h-2.381l1.532-1.824a1.11 1.11 0 011.855.244zM13 8.001h7v2h-2v9h-5V8zm-2 11H6v-9H4V8h7v11zM8.313 6a1.11 1.11 0 11.85-1.824L10.693 6H8.313z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;